<template>
  <div>
    <h5 class="info-text">{{$lang.titles.basic_settinsg}}</h5>

    <div class="md-layout">
      <div class="md-layout-item md-xsmall-size-100 md-medium-size-100 md-size-50 mx-auto">
        <md-field
          :class="[
            { 'md-valid': !errors.has('ID') && touched.ID },
            { 'md-form-group': true },
            { 'md-error': errors.has('ID') }
          ]"
        >
          <md-icon>perm_identity</md-icon>
          <label>ID</label>
          <md-input
            v-model="settings.id"
            data-vv-name="ID"
            type="text"
            name="ID"
            maxlength="8"
            v-validate="modelValidations.ID"
            style="text-transform:uppercase"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('ID')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('ID') && touched.ID">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-xsmall-size-100 md-medium-size-100 md-size-50 mx-auto">
        <md-field
          :class="[
            { 'md-valid': !errors.has('APP_KEY') && touched.APP_KEY },
            { 'md-form-group': true },
            { 'md-error': errors.has('APP_KEY') }
          ]"
        >
          <md-icon>vpn_key</md-icon>
          <label>{{$lang.inputs.application_key}}</label>
          <md-input
            v-model="settings.application_key"
            data-vv-name="APP_KEY"
            type="text"
            name="APP_KEY"
            maxlength="32"
            v-validate="modelValidations.KEY"
            style="text-transform:uppercase"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('APP_KEY')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('APP_KEY') && touched.APP_KEY">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-xsmall-size-100 md-medium-size-100 md-size-50 mx-auto">
        <md-field
          :class="[
            { 'md-valid': !errors.has('NET_KEY') && touched.NET_KEY },
            { 'md-form-group': true },
            { 'md-error': errors.has('NET_KEY') }
          ]"
        >
          <md-icon>vpn_key</md-icon>
          <label>{{$lang.inputs.network_key}}</label>
          <md-input
            v-model="settings.network_key"
            data-vv-name="NET_KEY"
            type="text"
            name="NET_KEY"
            maxlength="32"
            v-validate="modelValidations.KEY"
            style="text-transform:uppercase"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('NET_KEY')">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!errors.has('NET_KEY') && touched.NET_KEY">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>

import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    settings: {
      type: Object,
      default: {
        id: "",
        application_key: "",
        network_key: ""
      }
    }
  },
  data() {
    return {
      modelValidations: {
        ID: {
          required: true,
          regex: /^[A-Za-z0-9]+$/,
          min: 8,
          max: 8
        },
        KEY: {
          required: true,
          regex: /^[A-Fa-z0-9]+$/,
          min: 34,
          max: 34
        }
      },
      touched: {
        ID: false,
        APP_KEY: false,
        NET_KEY: false
      }
    };
  },
  methods: {
    validate() {
      return this.$validator.validateAll().then(res => {
        if (res) {
          this.settings.id = this.settings.id.toUpperCase();
          this.settings.application_key = this.settings.application_key.toUpperCase();
          this.settings.network_key = this.settings.network_key.toUpperCase();
          this.$emit("on-validated", true, this.settings);
        }
        return res;
      });
    }
  }
};
</script>

<style></style>